import { render, staticRenderFns } from "./Sacola.vue?vue&type=template&id=580e2ccd&scoped=true"
import script from "./Sacola.vue?vue&type=script&lang=js"
export * from "./Sacola.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../go/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580e2ccd",
  null
  
)

export default component.exports